
import { Mutation, useStore } from "@/store";
import { computed, defineComponent, onMounted, ref, Ref } from "vue";
import { showModalDialog } from "@/helpers/dialog";
import ButtonIcon from "@/components/primitive/ButtonIcon.vue";

export default defineComponent({
  name: "ErrorMessage",
  components: {
    ButtonIcon,
  },
  setup() {
    const store = useStore();
    const dialog: Ref = ref(null);

    onMounted(() => {
      showModalDialog(dialog.value);
    });

    const errors = computed(() => {
      return store.state.error.queue.map((error, index) => {
        return {
          message: error.message,
          index,
        };
      });
    });

    const onClose = () => {
      store.commit(Mutation.CLEAR_ERRORS);
    };

    return {
      dialog,
      errors,
      onClose,
    };
  },
});
